import "E:\\code\\nkyOrder\\trunk\\vantCommon\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "E:\\code\\nkyOrder\\trunk\\vantCommon\\node_modules\\core-js\\modules\\es.promise.js";
import "E:\\code\\nkyOrder\\trunk\\vantCommon\\node_modules\\core-js\\modules\\es.object.assign.js";
import "E:\\code\\nkyOrder\\trunk\\vantCommon\\node_modules\\core-js\\modules\\es.promise.finally.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import Vue from 'vue';
import App from './App.vue';
import router from '@/router';
import store from '@/store'; // Vue.config.productionTip = false

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
Vue.config.ignoredElements = ["wx-open-launch-app"]; //主css

import '@/assets/css/index.scss'; //svg文件夹

import '@/assets/icons'; //引入阿里巴巴矢量图

import '@/assets/Alibaba-Icon/iconfont.css'; //jsRSA加密

import jse from '@/assets/utils/jsencryptKey'; //覆盖vant默认组件样式

import '@/assets/css/vant-override.less';
import md5 from 'js-md5'; //公用类
//import Utils from "@/assets/utils/utils";
//Vue.prototype.Utils = Utils;

import * as filters from './plugins/filters.js';
Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]); //插入过滤器名和对应方法
});
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
Vue.prototype.$md5 = md5; //阻止显示生产模式的消息

Vue.config.productionTip = false;
new Vue({
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');